import { createAction, props } from '@ngrx/store';
import { FittingProduct } from 'src/app/models';
import { ProductSearchResult } from '../../models/product-search-result.model';

export const loadSearchResults = createAction('[Search] Load Search Resultsresults');
export const loadSearchResultsSuccess = createAction('[Search] Load Search Results Success', props<{ results: ProductSearchResult[] }>());
export const loadSearchResultsFailure = createAction('[Search] Load Search Results Failure', props<{ error: any }>());

export const activateSearchItem = createAction('[SEARCH] activate item', props<{ item: ProductSearchResult }>());
export const setFittingFilter = createAction('[SEARCH] set fitting filter', props<{fittingProduct: FittingProduct}>());

export const setSearchQuery = createAction('[Search] Set Search Query', props<{ q: string }>());
